import React, { memo } from 'react';

import { IconColors } from './iconConstants';
import { IconProps } from './iconInterfaces';

export const TriangleBadgeIcon = memo(({ 
    backgroundFillColor = IconColors.BackgroundFillColor,
    backgroundFillOpacity = IconColors.BackgroundFillOpacity,
    width = 30,
    height = 30
}: IconProps) =>
    <svg width={width} height={height} viewBox='0 0 20 18' xmlns='http://www.w3.org/2000/svg'>
        <g fill={backgroundFillColor} opacity={backgroundFillOpacity}>
            <path d='M19.0436 15.1252L19.0436 15.1252C19.7173 16.2888 18.8771 17.7499 17.53 17.7499H2.47C1.12285 17.7499 0.282712 16.2888 0.956356 15.1252L0.956371 15.1252L8.48636 2.11519C8.48636 2.11518 8.48637 2.11517 8.48637 2.11516C9.16008 0.951521 10.8399 0.951521 11.5136 2.11516C11.5136 2.11517 11.5136 2.11518 11.5136 2.11519L19.0436 15.1252Z'/>
        </g>
    </svg>
);
